import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import podcast from "../../../assets/social_media_icons/podcast.svg";
import facebook from "../../../assets/social_media_icons/facebook.svg";
import tiktok from "../../../assets/social_media_icons/tiktok.svg";
import linkedin from "../../../assets/social_media_icons/linkedin.svg";
import {ReactComponent as TwitterLogo} from "../../../assets/social_media_icons/twitter.svg";
import youtube from "../../../assets/social_media_icons/youtube.svg";
import instagram from "../../../assets/social_media_icons/instagram.svg";
import app_store_badge from "../../../assets/badges/app_store_badge.png";
import google_play_badge from "../../../assets/badges/google-play-badge.png";
import clubhouse from "../../../assets/social_media_icons/clubhouse.svg";
import { TFunction } from "i18next";
import { Translation } from "react-i18next";
import { extraSmallLayout } from "../../../utils/device";
import wechat from "../../../assets/social_media_icons/wechat.svg";
import { chunkArrayInGroups } from "../../../utils/utils";
import { BREAKPOINTS } from "../../../config/breakpoints";
import ResizableComponent from "../../resizable_component/resizable_component";
import "./template_page_footer.scss";

const SVG_ID = "#svg_id";

interface TemplatePageFooterProps {
    linksKeys: string[];
}

/** The footer that will be shown in each page */
class TemplatePageFooter extends ResizableComponent<TemplatePageFooterProps> {

    render() {

        let width = this.state.windowWidth;
        let maxColumns = 3;
        if (width < BREAKPOINTS.LG) {
            maxColumns = 2;
        }

        const arraySize = Math.max(2, Math.ceil(this.props.linksKeys.length / maxColumns));
        const footerLinks = chunkArrayInGroups(this.props.linksKeys, arraySize);

        const socialMedia = [
            {
                "label": "Podcast",
                "url": "https://podcast.luiss.it/",
                "link": `${podcast}${SVG_ID}`
            },
            {
                "label": "Facebook",
                "url": "https://www.facebook.com/uni.luiss",
                "link": `${facebook}${SVG_ID}`
            },
            {
                "label": "Instagram",
                "url": "https://www.instagram.com/uniluiss/",
                "link": `${instagram}${SVG_ID}`
            },
            {
                "label": "LinkedIn",
                "url": "https://it.linkedin.com/school/luiss-guido-carli-university/",
                "link": `${linkedin}${SVG_ID}`
            },
            {
                "label": "Twitter",
                "url": "https://twitter.com/uniLUISS",
                "link": `${linkedin}${SVG_ID}`
            },
            {
                "label": "Youtube",
                "url": "https://www.youtube.com/user/LUISSGuidoCarli",
                "link": `${youtube}${SVG_ID}`
            },
            {
                "label": "Tiktok",
                "url": "https://vm.tiktok.com/4JAtqe/",
                "link": `${tiktok}${SVG_ID}`
            },
            {
                "label": "WeChat",
                "url": "https://weixin.qq.com/r/rRxQSBrECEd3rV4r90m-",
                "link": `${wechat}${SVG_ID}`
            },
            {
                "label": "Clubhouse",
                "url": "https://www.joinclubhouse.com/club/luiss-university",
                "link": `${clubhouse}${SVG_ID}`
            }
        ];

        return (
            <Translation>
                {(t: TFunction) =>
                    <>
                        <Row className={`footer-row ${extraSmallLayout() ? "mobile" : "desktop"}`}>
                            <Col xl={5} lg={5} md={5} sm={6} xs={12}>
                                <Container className="site-areas">
                                    <Row>
                                        {footerLinks.map((items, index) =>
                                            <Col lg={4} xs={6} key={`footer-links-col-${index}`}>
                                                <ul>
                                                    {items.map(item => (
                                                        <li key={`footer-link-${item}`}><a href={t(`FOOTER link ${item} url`)}>
                                                            {t(`FOOTER link ${item} label`)}
                                                        </a></li>
                                                    ))}
                                                </ul>
                                            </Col>
                                        )}
                                    </Row>
                                </Container>
                            </Col>
                            <Col xl={5} lg={5} md={5} sm={6} xs={12}>
                                <Container>
                                    {/* Different layout for the socials
                                    <Row className="socials-icons pb-4">
                                        {socialMedia.map((value, index) => (
                                            <div className="col-4" key={index}>
                                                <a href={value.url} className="social-link d-flex justify-content-center" aria-label={value.label}>
                                                        <svg className="ml-4 mb-2 social-icon">
                                                            <use xlinkHref={`${value.link}`} />
                                                        </svg>
                                                </a>
                                            </div>
                                        ))}
                                    </Row> */}

                                    <Row className="socials">
                                        <Col xs={12}>
                                            <div className="float-sm-left float-none">
                                                <a href="https://podcast.luiss.it/" className="social-link" aria-label="podcast">
                                                    <svg className="mr-4 social-icon">
                                                        <use xlinkHref={`${podcast}${SVG_ID}`} />
                                                    </svg>
                                                </a>
                                                <a href="https://www.facebook.com/uni.luiss" aria-label="Facebook">
                                                    <svg className="mr-4 social-icon">
                                                        <use xlinkHref={`${facebook}${SVG_ID}`} />
                                                    </svg>
                                                </a>
                                                <a href="https://www.instagram.com/uniluiss/" aria-label="Instagram">
                                                    <svg className="ml-4 social-icon">
                                                        <use xlinkHref={`${instagram}${SVG_ID}`} />
                                                    </svg>
                                                </a>
                                                <a href="https://it.linkedin.com/school/luiss-guido-carli-university/">
                                                    <svg className="ml-4 social-icon" aria-label="LinkedIn">
                                                        <use xlinkHref={`${linkedin}${SVG_ID}`} />
                                                    </svg>
                                                </a>
                                                <a href="https://twitter.com/uniLUISS" aria-label="Twitter">
                                                    <TwitterLogo/>
                                                    {/* <svg className="ml-4 social-icon twitter">
                                                        <use xlinkHref={`${twitter}${SVG_ID}`} />
                                                    </svg> */}
                                                </a>
                                            </div>
                                            <div className="float-sm-left float-none">
                                                <a href="https://www.youtube.com/user/LUISSGuidoCarli" aria-label="Youtube">
                                                    <svg className="mr-4 social-icon">
                                                        <use xlinkHref={`${youtube}${SVG_ID}`} />
                                                    </svg>
                                                </a>
                                                <a href="https://vm.tiktok.com/4JAtqe/">
                                                    <svg className="ml-4 mr-4 social-icon" aria-label="Tiktok">
                                                        <use xlinkHref={`${tiktok}${SVG_ID}`} />
                                                    </svg>
                                                </a>
                                                <a href="https://weixin.qq.com/r/rRxQSBrECEd3rV4r90m-" aria-label="WeChat">
                                                    <svg className="social-icon">
                                                        <use xlinkHref={`${wechat}${SVG_ID}`} />
                                                    </svg>
                                                </a>
                                                <a href="https://www.joinclubhouse.com/club/luiss-university" aria-label="Clubhouse">
                                                    <svg className="social-icon">
                                                        <use xlinkHref={`${clubhouse}${SVG_ID}`} />
                                                    </svg>
                                                </a>
                                            </div>
                                            {extraSmallLayout() &&
                                                <p>{t("FOOTER text APP DOWNLOAD")}</p>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="stores">
                                        <Col xs={12}>
                                            <a href="https://apps.apple.com/it/app/luiss/id1039424016"><img src={app_store_badge} alt="Download-on-the-App-Store" /></a>
                                            <a href="https://play.google.com/store/apps/details?id=it.luiss.tsc"><img src={google_play_badge} alt="Google-Play" /></a>
                                        </Col>
                                    </Row>
                                </Container>
                            </Col>
                            <Col xl={2} md={2} xs={12} className="logos-col">
                                <div className="logos">
                                    <a href="https://www.qtem.org/">
                                        <img src="/qtem.svg" alt="logo Qtem" />
                                    </a>
                                    <a href="https://www.confindustria.it/home">
                                        <img src="/confindustria.svg" alt="logo Confindustria" />
                                    </a>
                                    <a href="https://ssun.info/">
                                        <img src="/ssun.svg" alt="logo SSUN" />
                                    </a>
                                    <a href="http://engageuniversity.eu/">
                                        <img src="/engage_logo.png" alt="logo engage" />
                                    </a>
                                    <a href="https://www.universitiesforclimate.org/">
                                        <img src="/climate_logo.png" alt="logo climate" />
                                    </a>
                                </div>
                            </Col>
                        </Row>
                        <Row className="credits-row">
                            <Col>
                                <p>
                                    {t("FOOTER text CREDITS")}
                                </p>
                            </Col>
                        </Row>
                    </>
                }
            </Translation>
        );
    }
}

export default TemplatePageFooter;
